import { render, staticRenderFns } from "./modal-input-form.vue?vue&type=template&id=75c499a4"
import script from "./modal-input-form.vue?vue&type=script&lang=ts"
export * from "./modal-input-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports